import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './config.js';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Shown in the UI by main.js; keeps a misconfigured build from failing silently.
  console.error('Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(SUPABASE_URL || 'http://invalid', SUPABASE_ANON_KEY || 'invalid', {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
});
